import type { FunctionTestWidgetConfig } from '../function-test.model';

export const FUNCTION_TEST_QUADRATIC_PRESET: FunctionTestWidgetConfig = {
  id: 'function-test-quadratic',
  type: 'function-test',
  params: {
    curve: {
      type: 'expression',
      expression: 'x * x - 4',
    },
  },
  display: {},
};
